import $ from 'jquery';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import lz from 'lz-string';
import PhotoSwipeLightBox from 'photoswipe/lightbox';
import 'photoswipe/style.css';

import 'swiper/css'; 
import 'swiper/css/navigation'; 
import 'swiper/css/pagination'; 
import 'swiper/css/thumbs'; 

$(function () {
    if ($('.property-page .swiper').length) {
        var prevIndex = -1;
        var previewSwiper = new Swiper(".property-page .preview-swiper", {
            modules: [Navigation, Pagination],
            spaceBetween: 10,
            slidesPerView: 2,
            loop: true,
            freeMode: true,
            watchSlidesProgress: true,
            direction: "vertical",
            allowTouchMove: false
        });
        var mainSwiper = new Swiper(".property-page .main-swiper", {
            modules: [Navigation, Pagination],
            spaceBetween: 16,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                799: {
                    slidesPerView: 1,
                    spaceBetween: 24
                }
            }
        });

        mainSwiper.on('slideChangeTransitionStart', function (swiper) {
            if (swiper.activeIndex >= prevIndex && swiper.activeIndex!=0) {
                previewSwiper.slideNext();
            } else {
                previewSwiper.slidePrev();
            }
            prevIndex = swiper.activeIndex;
        });
    }

    // Search result back/forth navigation
    const ln = $('.property-link-next');
    const lb = $('.property-link-back');
    if (window.location.search.indexOf('?x=') == 0 && lb.hasClass('lb')) {
        const m = $(ln).data('my-id');
        const x = window.location.search.substr(3);
        const d = lz.decompressFromEncodedURIComponent(x).split('|');
        const s = d[0], qry = d[1];

        $(lb).prop('href', '/' + s + qry);
        getAndSetNextLink(m, s, qry, $(ln));
        
    } else if (ln.length) {
        const $ln = $(ln),
            s = $ln.data('referrer-slug'),
            m = $ln.data('my-id'),
            qry = $ln.data('qry');

        getAndSetNextLink(m,s,qry,$ln);
    }   

    function getAndSetNextLink(m, s, qry, ln) {

        let sp = new URLSearchParams(qry);
        let fd = new FormData();
        for (const p of sp) {
            fd.append(p[0], p[1]);
        }

        $.ajax({
            url: '/ppi/propertysearchapi/nextpage/' + m + '?s=' + s,
            data: fd,
            processData: false,
            contentType: false,
            type: 'POST',
            success: function (data) {
                if (data != null) {
                    ln.prop('href', data + '?x=' + lz.compressToEncodedURIComponent(s + '|' + qry));
                }
            }
        });
    }

    const lightbox = new PhotoSwipeLightBox({
        gallery: '.main-swiper',
        children: 'a',
        pswpModule: () => import('photoswipe')
    });
    lightbox.init();

    if ($('a.plans').length) {
        const plansbox = new PhotoSwipeLightBox({
            gallery: '.plans-swiper',
            children: 'a',
            pswpModule: () => import('photoswipe')
        });
        plansbox.init();
        $('a.plans').on('click', function (evt) {
            evt.preventDefault();
            plansbox.loadAndOpen(0);
        });
    }
    if ($('a.epcs').length) {
        const epcsbox = new PhotoSwipeLightBox({
            gallery: '.epcs-swiper',
            children: 'a',
            pswpModule: () => import('photoswipe')
        });
        epcsbox.init();
        $('a.epcs').on('click', function (evt) {
            evt.preventDefault();
            epcsbox.loadAndOpen(0);
        });
    }
});
